export const environment = {
  production: true,
  api: 'https://api-office-notarial-pace.agence-11h10.fr',
  url: 'https://www.office-notarial-pace.com',
  //url: 'https://localhost.framework/',
  recaptcha: {
    siteKey: '6LfqbJMlAAAAAOYPGv9PqdGQLW8qUEbpBDDyigdT',
  },
};
